"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StoresContext_1 = require("./StoresContext");
var createActionsObject_1 = require("./Utils/createActionsObject");
var createProxyFromInitialValue_1 = require("./Utils/createProxyFromInitialValue");
/**
 * A provider component providing all connected components with shared access to
 * various context properties.
 */
var DepoProvider = /** @class */ (function (_super) {
    __extends(DepoProvider, _super);
    function DepoProvider(props) {
        var _this = _super.call(this, props) || this;
        var _a = createProxyFromInitialValue_1.default(_this.props.state.value), valueProxy = _a[0], getStoreNames = _a[1];
        _this.state = {
            depoState: _this.props.state,
            valueProxy: valueProxy,
            actions: createActionsObject_1.default(_this.props.state.stores),
            getStoreNames: getStoreNames
        };
        return _this;
    }
    DepoProvider.prototype.render = function () {
        return (React.createElement(StoresContext_1.default.Provider, { value: this.state }, this.props.children));
    };
    return DepoProvider;
}(React.Component));
exports.default = DepoProvider;
//# sourceMappingURL=DepoProvider.js.map